package music.jammers.client.shared.app.di

import music.jammers.client.shared.admin.di.adminModule
import music.jammers.client.shared.analytics.screen.ScreenAnalytics
import music.jammers.client.shared.auth.di.authSharedModule
import music.jammers.client.shared.component.avatar.di.avatarImageModule
import music.jammers.client.shared.component.card.info.di.cardInfoModule
import music.jammers.client.shared.component.member.info.legend.di.memberInfoLegendModule
import music.jammers.client.shared.event.di.eventModule
import music.jammers.client.shared.event.track.di.eventTrackModule
import music.jammers.client.shared.network.di.networkSharedModule
import music.jammers.client.shared.profile.di.profileModule
import music.limasoul.client.shared.instrument.di.instrumentModule
import music.limasoul.client.shared.navigation.navigationModule
import music.limasoul.client.shared.user.di.userSharedModule
import org.koin.core.component.KoinComponent

val sharedModules = listOf(
    analyticsSharedModule,
    authSharedModule,
    eventModule,
    profileModule,
    networkSharedModule,
    navigationModule,
    userSharedModule,
    eventTrackModule,
    instrumentModule,
    avatarImageModule,
    adminModule,
    cardInfoModule,
    memberInfoLegendModule,
)

object SharedComponent : KoinComponent {

    val screenAnalytics: ScreenAnalytics
        get() = getKoin().get<ScreenAnalytics>()
}